import cloudServiceModule from '../cloudService.module';

class ScimApiService {
    constructor(__env, $http, $q) {
        this.__env = __env;
        this.$http = $http;
        this.$q = $q;
    }

    getScimConfiguration(cloudToken) {
        const deferred = this.$q.defer();

        this.$http
            .get(`${this.getScimApiUrl()}/scim/admin/configuration`, {
                headers: {
                    token: cloudToken
                }
            })
            .then(response => deferred.resolve(response.data), response => deferred.reject(response.data));

        return deferred.promise;
    }

    setScimConfiguration(cloudToken, config) {
        const deferred = this.$q.defer();

        this.$http
            .post(`${this.getScimApiUrl()}/scim/admin/configuration`, config, {
                headers: {
                    token: cloudToken
                }
            })
            .then(response => deferred.resolve(response.data), response => deferred.reject(response.data));

        return deferred.promise;
    }

    generateNewBearerToken(cloudToken) {
        const deferred = this.$q.defer();

        this.$http
            .post(
                `${this.getScimApiUrl()}/scim/admin/token`,
                {},
                {
                    headers: {
                        token: cloudToken
                    }
                }
            )
            .then(response => deferred.resolve(response.data), response => deferred.reject(response.data));

        return deferred.promise;
    }

    getScimApiUrl() {
        let scimApiUrl = this.__env.scimApiUrl;
        let cloudUrl = this.__env.cloudUrl;

        return this.isValidUrl(scimApiUrl) ? scimApiUrl : cloudUrl + scimApiUrl;
    }

    isValidUrl(urlString) {
        try {
            new URL(urlString);
            return true;
        } catch (ex) {
            return false;
        }
    }
}

export default cloudServiceModule.service('scimApiService', ScimApiService);



// WEBPACK FOOTER //
// ./modules/cloudService/scim/scimApi.service.js